import { useState } from 'react';

import { WORDCLOUD_TOOLTIP_VERSION_HEIGHT } from 'constants/wordcloud';
import { useCurrentUserInfo } from 'hooks/useCurrentUserInfo';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';

/**
 * Hook to manage tooltip state for the WordCloud component
 *
 * @returns {Object} Tooltip state and handlers
 */
export const useTooltipState = (containerRef) => {
  const [tooltip, setTooltip] = useState(null);
  const { isLgUp } = useBreakpointFlags();
  const { isSuperAdminPermissions } = useCurrentUserInfo();

  const handleWordHover = (item, dimension) => {
    if (!isLgUp || !isSuperAdminPermissions) {
      return;
    }

    const [, , versions] = item || [];

    if (!versions?.length) {
      setTooltip(null);

      return;
    }

    const tooltipHeight = 16 + WORDCLOUD_TOOLTIP_VERSION_HEIGHT * versions.length;
    const containerRect = containerRef.current?.getBoundingClientRect();

    if (!containerRect) {
      return;
    }

    const anchorX = containerRect.left + dimension.x;
    const anchorY = containerRect.top + dimension.y;

    /* a virtual element that Popper can attach to */
    const virtualAnchor = {
      getBoundingClientRect: () => ({
        width: dimension.w,
        height: dimension.h + tooltipHeight,
        top: anchorY,
        bottom: anchorY,
        left: anchorX,
        right: anchorX,
      }),
      clientWidth: 0,
      clientHeight: 0,
    };

    setTooltip({ versions, anchorEl: virtualAnchor });
  };

  const clearTooltip = () => {
    setTooltip(null);
  };

  return {
    tooltip,
    handleWordHover,
    clearTooltip,
  };
};
